module.exports = __webpack_public_path__ + "static/media/headset.0ecf73cf.svg";